<template>
  <div>
    <the-nav-bar :title="$t('customerManagement.title')" />
    <md-field class="body-wrapper">
      <md-field-item
        v-for="router in routerList"
        :key="router.path"
        :title="router.title"
        arrow
        @click="goDetail(router.path)"
      ></md-field-item>
    </md-field>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { Field, FieldItem } from 'mand-mobile';
export default {
  components: {
    TheNavBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
  },
  computed: {
    routerList() {
      return [
        {
          title: this.$t('customerManagement.whitelist'),
          path: '/mine/userManage/whiteList',
        },
        {
          title: this.$t('customerManagement.blacklist'),
          path: '/mine/userManage/blackList',
        },
      ];
    },
  },
  methods: {
    goDetail(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-left: 0;
  padding-right: 0;

  .md-field-item:nth-child(even) {
    background: #f8fbfc;
  }

  & >>> {
    .md-field-item-content {
      min-height: 17.07vw;
      padding: 0 4.8vw;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      font-size: 3.73vw;
      font-weight: normal;
      text-align: right;
      color: color-primary;
    }
  }
}
</style>
